<template>
    <div class="agent-info">
        <img-box
            class="agent-head"
            :src="image"
            :alt="fullName"
            dir="width"
        ></img-box>
        <div class="info">
            <h3 class="agent-name" v-if="fullName">{{ fullName }}</h3>
            <p class="company" v-if="company">{{ company }}</p>
            <a
                class="email"
                v-if="email"
                :href="mailHref"
                rel="noopener noreferrer"
            >{{ email }}</a
            >
            <a
                class="phone"
                v-if="phone"
                :href="phoneHref"
                rel="noopener noreferrer"
            >{{ $ft.formatPhone(phone) }}</a
            >
        </div>
    </div>
</template>
<script>
export default {
    inheritAttrs: false,
    props: {
        image: String,
        fullName: String,
        company: String,
        email: String,
        phone: String
    },
    computed: {
        mailHref() {
            return `mailto:${this.email}`;
        },
        phoneHref() {
            return `tel:${this.phone}`;
        }
    }
};
</script>
<style lang="scss">
.md-sold-detail .agent-info {
    display: flex;
    .agent-head {
        flex-shrink: 0;
        width: 65px;
        height: 65px;
        border-radius: 50%;
    }
    .info {
        font-size: 12px;
        margin-left: 15px;
        word-break: break-word;
        a,
        p,
        h3 {
            display: block;
            text-align: left;
        }
        .agent-name {
            color: var(--color-theme);
            font-size: 16px;
            font-family: var(--font-bold);
            text-transform: capitalize;
            margin: 0;
            margin-bottom: 6px;
        }
        .company {
            color: var(--color-text);
            margin-bottom: 6px;
        }
        .email {
            color: var(--color-info);
            margin-bottom: 6px;
        }
        .phone {
            line-height: 1.5;
            text-decoration: underline;
            color: #249bff;
        }
    }
}
</style>
